import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createVNode as _createVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-3ca1e300")

_pushScopeId("data-v-3ca1e300")
const _hoisted_1 = { class: "chartname" }
const _hoisted_2 = { class: "tb" }
const _hoisted_3 = { class: "itme" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = /*#__PURE__*/_createVNode("div", null, "检测指标", -1)
const _hoisted_6 = /*#__PURE__*/_createVNode("div", { style: {"width":"100%","text-align":"right","padding-right":"25px"} }, "检测结果", -1)
const _hoisted_7 = /*#__PURE__*/_createVNode("div", null, "提示", -1)
const _hoisted_8 = /*#__PURE__*/_createVNode("div", null, "参考范围", -1)
const _hoisted_9 = { key: 0 }
const _hoisted_10 = {
  key: 0,
  class: "code-name-box"
}
const _hoisted_11 = {
  key: 1,
  class: "code-name-box"
}
const _hoisted_12 = {
  class: "val score-value",
  style: {"width":"100%","text-align":"right","padding-right":"25px"}
}
const _hoisted_13 = { class: "val score-trend" }
const _hoisted_14 = /*#__PURE__*/_createTextVNode("↓")
const _hoisted_15 = /*#__PURE__*/_createTextVNode("↑")
const _hoisted_16 = { key: 1 }
const _hoisted_17 = { class: "val" }
const _hoisted_18 = { key: 2 }
const _hoisted_19 = { class: "val" }
const _hoisted_20 = { key: 3 }
const _hoisted_21 = { class: "val" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_van_icon = _resolveComponent("van-icon")

  return (_openBlock(), _createBlock("div", {
    class: ["card version7", {'data-view': _ctx.styleView === 1}]
  }, [
    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.imgList, (img, index) => {
      return (_openBlock(), _createBlock("div", {
        key: img.name,
        ref: `imgGraphDom[${index}]`
      }, [
        _createVNode("img", {
          class: "chartimg",
          src: img.url,
          alt: img.name
        }, null, 8, ["src", "alt"]),
        _createVNode("div", _hoisted_1, [
          _createTextVNode(_toDisplayString(img.name) + " ", 1),
          (_ctx.styleView !== 1)
            ? (_openBlock(), _createBlock(_component_van_icon, {
                key: 0,
                style: {"top":"-2px","vertical-align":"middle"},
                name: "info-o",
                onClick: ($event: any) => (_ctx.openMeaningPopup({
        content: img.graphMeaning,
        title: img.name,
      },_ctx.$refs[`imgGraphDom[${index}]`],1))
              }, null, 8, ["onClick"]))
            : _createCommentVNode("", true)
        ])
      ], 512))
    }), 128)),
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        (_ctx.styleView !== 1)
          ? (_openBlock(), _createBlock("div", _hoisted_4, "序号"))
          : _createCommentVNode("", true),
        _hoisted_5,
        _hoisted_6,
        _hoisted_7,
        _hoisted_8
      ]),
      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.codeList, (code, i) => {
        return (_openBlock(), _createBlock("div", {
          class: "itme",
          key: code.name
        }, [
          (_ctx.styleView !== 1)
            ? (_openBlock(), _createBlock("div", _hoisted_9, _toDisplayString(i + 1), 1))
            : _createCommentVNode("", true),
          _createVNode("div", {
            onClick: ($event: any) => (_ctx.openMeaningPopup({
        content: code.meaning,
        title: code.name + ' 释义',
      },null,2))
          }, [
            (_ctx.styleView === 1)
              ? (_openBlock(), _createBlock("div", _hoisted_10, [
                  _createVNode("span", null, _toDisplayString(code.name), 1),
                  _createVNode("span", null, _toDisplayString(code.codeName), 1)
                ]))
              : (_openBlock(), _createBlock("div", _hoisted_11, [
                  _createTextVNode(_toDisplayString(code.name) + " ", 1),
                  _createVNode(_component_van_icon, {
                    class: "code-icon",
                    name: "info-o",
                    style: {"float":"right","top":"0px","vertical-align":"middle","z-index":"1","right":"-6px"}
                  })
                ]))
          ], 8, ["onClick"]),
          _createVNode("div", null, [
            _createVNode("span", _hoisted_12, _toDisplayString(code.score), 1)
          ]),
          _createVNode("div", null, [
            _createVNode("span", _hoisted_13, [
              (code.description == -1)
                ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
                    _hoisted_14
                  ], 64))
                : _createCommentVNode("", true),
              (code.description == 1)
                ? (_openBlock(), _createBlock(_Fragment, { key: 1 }, [
                    _hoisted_15
                  ], 64))
                : _createCommentVNode("", true)
            ])
          ]),
          (code.minInterval && code.maxInterval)
            ? (_openBlock(), _createBlock("div", _hoisted_16, [
                _createVNode("span", _hoisted_17, _toDisplayString(code.minInterval + '~' + code.maxInterval), 1)
              ]))
            : (code.minInterval)
              ? (_openBlock(), _createBlock("div", _hoisted_18, [
                  _createVNode("span", _hoisted_19, "≥" + _toDisplayString(code.minInterval), 1)
                ]))
              : (code.maxInterval)
                ? (_openBlock(), _createBlock("div", _hoisted_20, [
                    _createVNode("span", _hoisted_21, "≤" + _toDisplayString(code.maxInterval), 1)
                  ]))
                : _createCommentVNode("", true)
        ]))
      }), 128))
    ])
  ], 2))
})